import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=3ab71957&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotFound.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab71957",
  null
  
)

export default component.exports